import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { AngularContext } from 'react-app';
import { getCourseFontColor } from 'redux/selectors/course';
import { useScrollTop } from 'shared/hooks/use-scroll';

interface CourseHomeUtils {
  isWhiteIcon: boolean;
  isEditOrReorderMode: boolean;
}

/**
 * Hook to provide common utilities for course home header components
 * @returns Object containing:
 *  - isWhiteIcon: boolean indicating if icons should be rendered in white
 *  - isEditOrReorderMode: boolean indicating if we're in edit or reorder mode
 */
export const useCourseHomeUtils = (): CourseHomeUtils => {
  const { injectServices } = useContext(AngularContext);
  const [$state, LecturePageManager, TimelinesManager] = injectServices([
    '$state',
    'LecturePageManager',
    'TimelinesManager',
  ]);

  const courseFontColor = useSelector(getCourseFontColor);
  const isTopHeaderScrolling = useScrollTop(document.getElementById('main-panel'));

  // Check if we're on course home for styling
  const isCourseHome = () => {
    const stateNames = ['course-home', 'course-home-edit', 'program-home'];
    return stateNames.includes($state.current.name);
  };

  const isWhiteIcon = isCourseHome() && !isTopHeaderScrolling && courseFontColor === '#FFF';

  const isEditOrReorderMode = LecturePageManager.isEditMode()
    || LecturePageManager.isReorderMode()
    || TimelinesManager.isEditMode()
    || TimelinesManager.isReorderMode();

  return {
    isWhiteIcon,
    isEditOrReorderMode,
  };
};

export default useCourseHomeUtils;
